export const inputStyles = {
    input: isError => ({ width: 250, height: 25, ...(isError ? { border: 'solid 1px red' } : {}) })
};
